import { CitrusViewContent } from './CitrusViewContent';
import { CitrusViewProvider } from '../../contexts/CitrusViewContext';

export const CitrusView = () => {
  return (
    <CitrusViewProvider>
      <div className="flex flex-col items-center">
        <CitrusViewContent />
      </div>
    </CitrusViewProvider>
  );
};
